import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-16">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img
                src="/images/qupid.svg"
                alt="Qupid Logo"
                className="h-8"
              />
            </div>
            <p className="text-gray-400 mb-4 max-w-sm">
              Comprehensive data observability platform for
              modern data teams. Monitor, track, and improve
              your data quality across all sources.
            </p>
            <div className="flex items-center gap-2 px-3 py-2 bg-gray-800 rounded-lg w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className="text-xs text-gray-400">On-premise deployment. Your data never leaves your infrastructure.</span>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <FooterLink scrollToId="features">Features</FooterLink>
              <FooterLink href="/pricing">Pricing</FooterLink>
              <FooterLink scrollToId="integrations">Integrations</FooterLink>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <FooterLink href="https://learn.qupid.io/docs">Documentation</FooterLink>
              <FooterLink href="https://learn.qupid.io/blog">Blog</FooterLink>
              <FooterLink href="/case-studies">Case Studies</FooterLink>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <FooterLink href="/about">About</FooterLink>
              <FooterLink href="/careers">Careers</FooterLink>
              <FooterLink href="/contact">Contact</FooterLink>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Qupid. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ href, children, scrollToId }) => {
  const location = useLocation();

  if (scrollToId) {
    return (
      <li>
        <Link
          to={`/#${scrollToId}`}
          onClick={(e) => {
            if (location.pathname === '/') {
              e.preventDefault();
              const element = document.getElementById(scrollToId);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }
          }}
          className="text-gray-400 hover:text-white transition-colors duration-200"
        >
          {children}
        </Link>
      </li>
    );
  }

  if (href.startsWith('http')) {
    return (
      <li>
        <a
          href={href}
          className="text-gray-400 hover:text-white transition-colors duration-200"
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      </li>
    );
  }

  return (
    <li>
      <Link
        to={href}
        className="text-gray-400 hover:text-white transition-colors duration-200"
      >
        {children}
      </Link>
    </li>
  );
};

export default Footer;
